var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0438 6.09755H10.4558V0.86855C10.4517 0.639626 10.359 0.421227 10.1971 0.259327C10.0352 0.0974277 9.81675 0.00466092 9.58783 0.00055367C9.47212 -0.00363175 9.35679 0.0159478 9.24895 0.0580869C9.14111 0.100226 9.04305 0.164033 8.96083 0.245556L0.244835 8.96055C0.0874126 9.13121 0 9.35487 0 9.58705C0 9.81922 0.0874126 10.0429 0.244835 10.2136L8.93383 18.9026C9.11268 19.0678 9.34454 19.1638 9.58783 19.1735C9.70291 19.1776 9.81759 19.1579 9.92474 19.1157C10.0319 19.0735 10.1292 19.0098 10.2106 18.9283C10.292 18.8469 10.3558 18.7496 10.398 18.6425C10.4402 18.5353 10.4599 18.4206 10.4558 18.3056V13.0766H20.0438C20.2728 13.0724 20.4912 12.9797 20.6531 12.8178C20.815 12.6559 20.9077 12.4375 20.9118 12.2086V6.97755C20.9077 6.74863 20.815 6.53023 20.6531 6.36833C20.4912 6.20643 20.2728 6.11366 20.0438 6.10955V6.09755Z",
    fill: "#3067AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.da931ca3cb85a4907f00510ee3eb4838.svg";
export { ForwardRef as ReactComponent };